/**
 * Pure functions for pickleball serve rotation.
 * Ported from server/serve-logic.js — no external dependencies.
 */

export function computeNextServe({
  currentPos,
  currentServerPlayerId,
  servingTeamId,
  receivingTeamId,
  team1Id,
  serverNum,
  isFirstServe,
  isDoubles,
  serverWon,
  servingTeamPlayer2Id  = null,
  receivingTeamPlayer1Id = null,
}) {
  const nextPos = { ...currentPos };

  let nextServerTeamId   = servingTeamId;
  let nextServerNum      = serverNum;
  let nextServerPlayerId = currentServerPlayerId;
  let rallyType          = 'point';

  if (serverWon) {
    if (isDoubles) {
      if (servingTeamId === team1Id) {
        const tmp = nextPos.TL; nextPos.TL = nextPos.BL; nextPos.BL = tmp;
        if (nextPos.TL === undefined) delete nextPos.TL;
        if (nextPos.BL === undefined) delete nextPos.BL;
      } else {
        const tmp = nextPos.TR; nextPos.TR = nextPos.BR; nextPos.BR = tmp;
        if (nextPos.TR === undefined) delete nextPos.TR;
        if (nextPos.BR === undefined) delete nextPos.BR;
      }
    }
  } else {
    const HOME_ZONE          = receivingTeamId === team1Id ? 'BL' : 'TR';
    const SERVING_TEAM_ZONES = servingTeamId  === team1Id ? ['TL', 'BL'] : ['TR', 'BR'];

    if (!isDoubles) {
      nextServerTeamId   = receivingTeamId;
      nextServerNum      = 1;
      nextServerPlayerId = receivingTeamPlayer1Id;
      rallyType          = 'side_out';
    } else if (isFirstServe) {
      nextServerTeamId   = receivingTeamId;
      nextServerNum      = 1;
      nextServerPlayerId = nextPos[HOME_ZONE] || receivingTeamPlayer1Id;
      rallyType          = 'side_out';
    } else if (serverNum === 1) {
      nextServerTeamId = servingTeamId;
      nextServerNum    = 2;
      const partnerZone = SERVING_TEAM_ZONES.find(
        z => nextPos[z] && nextPos[z] !== currentServerPlayerId
      );
      nextServerPlayerId = (partnerZone && nextPos[partnerZone]) || servingTeamPlayer2Id;
      rallyType          = 'second_server';
    } else {
      nextServerTeamId   = receivingTeamId;
      nextServerNum      = 1;
      nextServerPlayerId = nextPos[HOME_ZONE] || receivingTeamPlayer1Id;
      rallyType          = 'side_out';
    }
  }

  return { nextPos, nextServerPlayerId, nextServerTeamId, nextServerNum, rallyType };
}
